import axios from 'axios';
import React, {useEffect, useState} from 'react';

import {text} from '../../text';
import {URLS} from '../../config';
import {hooks} from '../../hooks';
import {theme} from '../../constants';
import {components} from '../../components';
import {actions} from '../../store/actions';

export const CartEmpty: React.FC = () => {
  const dispatch = hooks.useAppDispatch();
  const navigate = hooks.useAppNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  const [productsData, setProductsData] = useState<any>([]);

  const getData = async () => {
    setLoading(true);

    try {
      const products = await axios
        .get(URLS.GET_PRODUCTS)
        .then((res) => res.data.products);

      setProductsData(products);
    } catch (error) {
//      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header title='Cart' burger={true} basket={true} line={true} />
    );
  };

  const renderContent = (): JSX.Element => {
    if (loading) return <components.Loader />;

    return (
      <main
        style={{
          padding: '0px 20px 94px 20px',
          marginTop: 52,
          paddingTop: '18vh',
        }}
      >
        <img
          src={require('../../assets/icons/27.png')}
          alt='order successful'
          style={{
            width: 123.39,
            marginBottom: 14,
          }}
        />
        <text.H2
          style={{
            marginBottom: 14,
            color: theme.colors.mainColor,
            textTransform: 'capitalize',
          }}
        >
          Your cart is empty!
        </text.H2>
        <text.T16
          style={{
            whiteSpace: 'pre-line',
            marginBottom: 30,
            color: theme.colors.textColor,
          }}
        >
          Looks like you haven't made{'\n'}your order yet.
        </text.T16>
        <components.Button
          title='shop now'
          style={{
            color: '#fff',
          }}
          colorScheme='light'
          onClick={() => {
            dispatch(actions.resetFilters());
            navigate('/Shop', {state: {products: productsData}});
          }}
          containerStyle={{marginBottom: 0, width: '100%'}}
        />
      </main>
    );
  };

  // const renderBottomTabBar = () => {
  //   return <components.BottomTabBar />;
  // };

  return (
    <div
      style={{
        // backgroundColor: 'orange',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      {renderHeader()}
      {renderContent()}
      {/* {renderBottomTabBar()} */}
    </div>
  );
};
